import { Sidebar } from 'primereact/sidebar';
import {
  DropdownValueTemplateType,
  DropdownItemTemplateType,
} from 'primereact/dropdown';
import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import hamburger from '../../assets/icons/hamburger.svg';
import './index.css';
interface Props {
  visible: boolean;
  setVisible: React.Dispatch<React.SetStateAction<boolean>>;
  value: string;
  options: any[];
  valueTemplate: DropdownValueTemplateType;
  itemTemplate: DropdownItemTemplateType;
  onChange: (e: any) => void;
}
const SideBarMenu: React.FC<Props> = ({
  visible,
  setVisible,
  value,
  options,
  valueTemplate,
  itemTemplate,
  onChange,
}) => {
  let activeClassName = 'nav-active px-4 py-3';
  const { t } = useTranslation();
  const clickHandler = () => setVisible(false);
  const [languageSidebar, setLanguageSidebar] = useState(false);

  const customIcons = (
    <>
      <button className="text-base mr-2" onClick={clickHandler}></button>
    </>
  );
  const mobileIcons = (
    <div className="flex justify-content-between text-lg">
      <button
        className="flex align-items-center text-base"
        onClick={() => setLanguageSidebar(false)}
      >
        <i className="pi icon-arrow-down rotate-180 mr-1 "></i>
        {t('BACK')}
      </button>
    </div>
  );
  const routerLink = [
    { title: t('HOME'), path: '/' },
    { title: t('CONFIGURATOR'), path: '/configurator' },
    { title: t('SAVE_QUOTE'), path: '/saveQuote' },
  ];
  return (
    <>
      <Sidebar
        visible={visible}
        icons={customIcons}
        onHide={clickHandler}
        fullScreen={true}
        blockScroll={true}
        className="menu"
      >
        <nav className="pt-3">
          <section className="flex flex-column">
            {routerLink.map(({ title, path }, index) => (
              <NavLink
                onClick={clickHandler}
                key={index}
                className={({ isActive }) =>
                  isActive ? activeClassName : 'default_color px-4 py-3'
                }
                to={path}
              >
                {title}
              </NavLink>
            ))}
            <div
              onClick={() => setLanguageSidebar(true)}
              className="language flex justify-content-between align-items-center px-4 py-3"
            >
              <div>
                <span className="primary-color">
                  <span className="text-base font-bold  mr-3">
                    {t('LANGUAGE')}
                  </span>
                  {
                    options
                      .find((opt) => opt.value === value)
                      .label.split('|')[0]
                  }
                </span>
              </div>
            </div>
          </section>
        </nav>
      </Sidebar>
      <Sidebar
        visible={languageSidebar}
        position={'right'}
        icons={mobileIcons}
        onHide={() => {
          setLanguageSidebar(false);
          setVisible(false);
        }}
        fullScreen={true}
        blockScroll={true}
        className="menu menu-alt"
      >
        <ul className=" language-drops">
          {options.map((opt) => {
            const data = opt.label.split('|');
            return (
              <li
                key={opt.value}
                className="text-base"
                onClick={() => {
                  setLanguageSidebar(false);
                  onChange({ value: opt.value });
                }}
              >
                <strong>{data[0]}</strong> {data[1] ? `| ${data[1]}` : ''}
              </li>
            );
          })}
        </ul>
      </Sidebar>
      <button
        onClick={() => setVisible(true)}
        className="hamburger flex align-items-center"
      >
        <img alt="menu" width={35} height={30} src={hamburger} />
      </button>
    </>
  );
};

export default SideBarMenu;
